<template>
  <div class="content if-profile report-tab">
    <div class="md-layout finanical-insights-body">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header m-0">
         <VRHeader :headerData="this.headerData"/>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 p-0 mt-4">
        <h1 class="section_header">Industry Market Analysis</h1>
        <nav-tabs-card class="m-0">
          <template slot="content">
            <div class="md-layout if_card">
              <md-tabs class="environment_div">
                <md-tab md-label="Tables" md-icon="table_chart" class="p-0">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 p-0">
                      <md-card class="m-0">
                        <md-card-header>Industry Market Benchmarks</md-card-header>
                        <md-card-content>
                            <div class="md-layout px-4 mt-4">
                              <div class="md-layout-item md-medium-size-100 md-size-100 blue-tbl">
                                <div class="sub_table">
                                  <md-table
                                      v-model="VRIndustryMarketBenchmarks"
                                      table-header-color="blue"
                                      class="profit-and-loss-table"
                                  >
                                    <md-table-row>
                                      <md-table-head ></md-table-head>
                                      <md-table-head class="align-div-components" colspan="3">INDUSTRY</md-table-head>
                                      <md-table-head class="align-div-components" colspan="3">FIRM</md-table-head>
                                      <!--<md-table-head>FIRM</md-table-head>
                                      <md-table-head></md-table-head>
                                      <md-table-head></md-table-head>-->
                                    </md-table-row>
                                    <md-table-row  v-for="item in VRIndustryMarketBenchmarks" :key="item.id">
                                      <md-table-cell md-label="">
                                        <div class="md-table-side-label">
                                          {{ item.benchmark }}
                                        </div>
                                      </md-table-cell>
                                      <md-table-cell v-for="(key,i) in Object.keys(item.industry)" :key="'industry_'+i">
                                        {{ item.industry[key] }}
                                      </md-table-cell>
                                     
                                     <md-table-cell class="market-last-el" v-for="(key,j) in Object.keys(item.firm)" :key="'firm_'+j">
                                        {{ item.firm[key] }}
                                      </md-table-cell>
                                  
                                    </md-table-row>
                                  </md-table>
                                </div>
                              </div>
                            </div>
                        </md-card-content>
                      </md-card>
                    </div>
                    <div class="md-layout-item md-size-100 mt-4">
                      <md-card class="md-card-profile px-4">
                        <md-card-header>
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                              Market Population Demographics
                            </div>
                          </h4>
                        </md-card-header>
                        <md-card-content>
                          <div class="extra_space">
                          <p>
                            The {{ this.companyName ? this.companyName : "Company" }} competitive industry market
                            area analysis is based on the
                            {{ !this.vestimateReport.all_us ? this.vestimateReport.MR.area : "US Market Area" }}. Total
                            population in the market area is {{ this.vestimateReport.MR['measures']['Population'] }}
                            in {{ this.vestimateReport.MR['measures']['Households'] }} households with a median age of
                            {{ this.vestimateReport.MR['measures']['Median Age'] }}. The
                            adult age breakdown is: Millennials (20-34):
                            {{ this.vestimateReport.MR['measures']['Millennials'] }};
                            Gen Xers (35-54): {{ this.vestimateReport.MR['measures']['Genx'] }}; Boomers (55-74):
                            {{ this.vestimateReport.MR['measures']['Boomers'] }}.
                            <br/>
                            {{ this.vestimateReport.MR['measures']['Bachelors'] }} of the population boasts a bachelor’s
                            degree or
                            higher; another {{ this.vestimateReport.MR['measures']['Associate'] }} holds an associate
                            degree.
                            <br/>
                            Median housing value in the market area is
                            {{ this.vestimateReport.MR['measures']['Median Household Value'] }},
                            while the median rent level is {{ this.vestimateReport.MR['measures']['Median Rent'] }} per
                            month. Per
                            capita income in the market area is
                            {{ this.vestimateReport.MR['measures']['Per Capita Income'] }}, while
                            average (mean) household income is {{
                              this.vestimateReport.MR['measures']['Mean HH income']
                            }} and median
                            household income is {{ this.vestimateReport.MR['measures']['Median HH Income'] }}. 27.84% of
                            market area
                            households earn over one hundred thousand dollars per
                            year. <br/>
                          </p>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                    <div class="md-layout-item md-size-100">
                      <md-card class="md-card-profile px-4">
                        <md-card-header>
                          <h4 class="title m-0">
                            <div class="md-layout-item md-medium-size-100 md-size-100 card-title p-0">
                              Industry Market Context
                            </div>
                          </h4>
                        </md-card-header>
                        <md-card-content>
                          <div class="extra_space">
                          <p>
                            In this market area, the {{ this.industryName }} industry includes
                            {{ this.vestimateReport.MR['measures']['Industry Operations'] }}
                            operations; {{ this.vestimateReport.MR['measures']['Firms'] }} independent firms and
                            {{ this.vestimateReport.MR['measures']['Branches'] }} branch
                            establishments. Among the independent firms,
                            {{ this.vestimateReport.MR['measures']['Small Businesses'] }} fall
                            within the small business definition of single site
                            firms with fewer than twenty-five employees.
                            Total industry employment is
                            ${{ this.numberWithPoints(this.vestimateReport.MR['measures']['Employment']) }}. Of these,
                            {{ this.numberWithPoints(this.vestimateReport.MR['measures']['SB Employment']) }} are
                            employed in small business operations of fewer than 25
                            employees. The average industry operation has
                            {{ this.vestimateReport.MR['measures']['Average Employment'] }}
                            employees. <br/>
                            In {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }},
                            industry operations in the market area
                            accounted for a total market volume of
                            {{ this.vestimateReport.MR['measures']['Annual Market Sales Volume'] }}.
                            Of that, the industry market small business segment
                            accounts for {{ this.vestimateReport.MR['measures']['SB Market Share Volume'] }} in sales.
                            The small business
                            share of the total market has {{
                              this.vestimateReport.MR['measures']['SB Market Share text']
                            }} from {{ this.vestimateReport.MR['measures']['SB Market Share Year 1'] }} to
                            {{ this.vestimateReport.MR['measures']['SB Market Share Year 3'] }} since
                            {{ this.vestimateReport.IF['ifDataYears'][0] }}.<br/>
                            Most recent annual {{ this.companyName ? this.companyName : "Company" }} sales are
                            ${{
                              this.numberWithPoints(this.vestimateReport.input_structure.IFInputs[this.vestimateReport.recentYear]['revenue']['value'])
                            }}.
                            By contrast, average annual industry site
                            sales are {{ this.vestimateReport.MR['measures']['Average Site Sales'] }}. Median site sales
                            are {{ this.vestimateReport.MR['measures']['Median Site Sales'] }}.
                            Market area small business sales average
                            {{ this.vestimateReport.MR['measures']['Average Small Business Sales'] }}.
                            Average annual industry site sales have
                            {{
                              this.vestimateReport.MR['measures']['Avg Site Sale Change'].replace("%", "") > 0 ? "decreased" : "increased"
                            }}
                            by
                            {{ this.vestimateReport.MR['measures']['Avg Site Sale Change'].replace("-", "") }} in the
                            three calendar years {{ this.vestimateReport.IF['ifDataYears'][0] }} to
                            {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }}; market
                            area average small business sales
                            {{ this.vestimateReport.MR['measures']['Avg SB Sale Change Text'] }} by
                            {{ this.vestimateReport.MR['measures']['Avg SB Sale Change'] }}
                            during the same period.<br/>
                            {{ this.companyName ? this.companyName : "Company" }} sales rank
                            {{ this.vestimateReport.calculations['sales_rank'] }} industry
                            operations in the market area—a percentile rating of
                            {{ this.vestimateReport.calculations['sales_rank_percentile'] }}.
                            {{ this.companyName ? this.companyName : "Company" }} holds a
                            {{ this.vestimateReport.MR['measures']['Film Market Share'] }} share of market
                            sales, which {{ this.vestimateReport.MR['measures']['Firm Market Share Text'] }} percentage
                            points since
                            {{ this.vestimateReport.IF['ifDataYears'][0] }}.
                            <span v-if="this.vestimateReport.MR['penetration']['US Sales per Person']">
                              The {{
                                this.industryName
                              }} industry captures {{ this.vestimateReport.MR['penetration']['US Sales per Person'] }} in sales per person
                              at the national level{{
                                !this.vestimateReport.all_us ? ", while market area sales per person is " + this.vestimateReport.MR['penetration']['Market Sales per Person'] : ""
                              }}. US industry sales per household are
                              {{ this.vestimateReport.MR['penetration']['US Sales per Household'] }}.
                                <span v-if="!this.vestimateReport.all_us">
                                   By contrast, market area sales per household are calculated at {{
                                    this.vestimateReport.MR['penetration']['Market Sales per Household']
                                  }}.
                                </span>

                              This and related
                              indicators (e.g., Sales per Person or Sales per
                              Business Establishment) may suggest whether the {{
                                !this.vestimateReport.all_us ? "local" : ""
                              }}
                              industry market is saturated or under‐served,
                              reflecting opportunities for firm expansion or growth.
                              Only one or two of these metrics may be relevant to
                              the specific industry or firm, depending on its
                              customer target. This valuation does not include a
                              calculated Sales per Household score in the case of
                              most B-to-B industries.
                              {{
                                !this.vestimateReport.all_us ? "Where a local market has been selected, the sales per household variance is applied as a Market Opportunity Index metric to value calculations." : ""
                              }}
                              <br/>
                            </span>

                            {{ this.vestimateReport.MR['measures']['Startups'] }} independent industry startups and new
                            branch
                            operations were identified in the market area at the
                            end of {{ this.vestimateReport.IF['ifDataYears'][this.vestimateReport.last_year_index] }},
                            creating a new operation rate of
                            {{ this.vestimateReport.MR['measures']['Market Industry Startup Rate'] }} in
                            the most recent analysis year
                            {{
                              !this.vestimateReport.all_us ? ", " + this.vestimateReport.MR['measures']['Industry Startup Rate Text'] + " than the national industry rate of " + this.vestimateReport.MR['measures']['US Industry Startup Rate'] : ""
                            }}.
                            Unusually low new
                            operation rates can indicate market saturation or lack
                            of perceived opportunity, while high rates suggest
                            both opportunity and the recognition of it. <br/>

                            Over {{ this.vestimateReport.IF['ifDataYearsFull'][1] }} -
                            {{ this.vestimateReport.IF['ifDataYearsFull'][2] }},
                            {{ this.vestimateReport.MR['measures']['Cessation'] }} of industry establishments in
                            this market area ceased operation.
                            {{
                              !this.vestimateReport.all_us ? "US industry cessation rates were " + this.vestimateReport.MR['measures']['Cessation US'] : ""
                            }}.
                          </p>
                          </div>
                        </md-card-content>
                      </md-card>
                    </div>
                  </div>
                </md-tab>
              </md-tabs>
            </div>
          </template>
        </nav-tabs-card>
      </div>
    </div>
  </div>
</template>
<style scope>
.blue-tbl tr td:last-child {
  color: #000 !important;
}
</style>
<script>
import VRHeader from './_partials/VRHeader';
import {NavTabsCard} from "@/components";
import {mapState} from "vuex";

export default {
  components: {
    NavTabsCard,
    VRHeader,
  },
  props: ['headerData'],
  data() {
    return {
      VRIndustryMarketBenchmarks: [],
      basicInfo: [
        {
          name: "Industry Market Benchmarks"
        },
        {
          name: "FTE Employees",
        },
        {
          name: "Sales per Employee",
        },
        {
          name: "FTE Average Wage",
        },
        {
          name: "Industry Peer Group Firms Analyzed",
        },
        {
          name: "Industry Market Average Site Sales",
        },
        {
          name: "Industry Market Gross Volume",
        },
        {
          name: "Market Sales/Household",
        },
        {
          name: "US Sales/Household",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      client: (state) => state.user.vestimate_report.data.developerClient,
      vestimateReport: state => state.user.vestimate_report.data,
      naics: state => state.user.vestimate_report.data.IMRnaics,
      industryName: state => state.user.vestimate_report.data.IMRindustry,
      displayArea: state => state.user.vestimate_report.data.MR.area,
      reportDate: state => state.user.vestimate_report.data.report_date,
      companyName: state => state.user.vestimate_report.data.input_structure['Company Name']['value']
    }),
  },
  mounted() {
    let section = this.$route.query.section;

    if (!section) {
      section = "dollar";
    }

    this.switchView(section);
    let fullYears = this.vestimateReport.IF['ifDataYearsFull'];
    fullYears = fullYears.map(Number);
    let f = {};
    f.benchmark = "";
    f.industry = {};
    f.firm = {};
    this.basicInfo.forEach((element, index) => {
      let c = {};
      c.industry = {};
      c.firm = {};
      c['benchmark'] = element.name;
      fullYears.forEach((el) => {
        c.industry[el] = this.vestimateReport.IF.data[el][element.name] ? this.vestimateReport.IF.data[el][element.name].dollar : "";
        c.firm[el] = this.vestimateReport.IF.data[el][element.name] ? this.vestimateReport.IF.data[el][element.name].firm_dollar : "";
        f.industry[el] = el;
        f.firm[el] = el;
      })
      this.VRIndustryMarketBenchmarks.push(c);
    })
    this.VRIndustryMarketBenchmarks.unshift(f);

  },

  methods: {
    switchView: function (type) {
      this.view = type;
    },
    numberWithPoints(x) {
      if (typeof x === 'number') {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      } else if(x === null){
        return x;
      }else
      {
        return x.replace(/,/g, '.');
      }
    },
  },
};
</script>
<style lang="scss">
.finanical-insights-body {
  .header-box {
    display: flex;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }

  .md-collapse-content, .finanical-insights-body .md-card-content {
    padding: 0;
  }

  .financal-report-col-1 {
    display: flex;
    align-items: center;
  }

  .fi-profile-pdf-box {
    display: flex;
    justify-content: flex-end;
  }

  .profile-title {
    font-size: 24px;
    font-weight: 400;
  }
}

.industry-insights-table {
  display: flex;
  align-items: flex-start;
}

.environment_div {
  .md-tabs-navigation {
    display: none;
  }
}
</style>
